export const feedTypes = ['global', 'local', 'network', 'search'] as const;
export type FeedType = (typeof feedTypes)[number];

export const messageListTypes = ['inbox', 'unread', 'online', 'deleted', 'search'] as const;
export type MessageListType = (typeof messageListTypes)[number];

export const peopleListTypes = [
  'online',
  'nearby',
  'following',
  'followers',
  'visitors',
  'new',
  'birthdays',
  'search',
] as const;
export type PeopleListType = (typeof peopleListTypes)[number];

export const nearbyFilterOptions = ['online', 'recent', 'active', 'newmembers', 'all'] as const;
export type NearbyFilterOption = (typeof nearbyFilterOptions)[number];

export const eventListTypes = ['upcoming', 'nearby', 'network', 'past'] as const;
export type EventListType = (typeof eventListTypes)[number];

export const photoListTypes = ['latest', 'network', 'private', 'favorites'] as const;
export type PhotoListType = (typeof photoListTypes)[number];
